// Shared constants

export const CATEGORIES = [
  'Buttons',
  'CheckBoxes',
  'Toggle Switches',
  'Cards',
  'Loaders',
  'Inputs',
  'Radio Buttons',
  'Forms',
  'ToolTips',
  'Misc'
];
